export default __webpack_public_path__ + "static/media/world-multiple-mode-dialog.ff0bae54.png";